// extracted by mini-css-extract-plugin
export var content = "_ov-1";
export var fullScreen = "_ov-0";